// extracted by mini-css-extract-plugin
module.exports = {"barChartWrapper":"style__barChartWrapper__t+U6H"};